<dictionaries-layout [title]="title" [type]="dictionaryType">
  <div class="fuel-data-wrapper">
    <fca-data-table
      *ngIf="data"
      [dataDefinition]="dataDefinition"
      [data]="data"
      [customButtons]="customButtons"
      [pageSize]="pageSize"
    ></fca-data-table>
    <div *ngIf="data == null" class="no-data-placeholder">
      Fill form fields to display data
    </div>
  </div>
  <button mat-flat-button class="add-button" (click)="addUnitConverter()">
    Add new
  </button>
</dictionaries-layout>

